import { log } from "../../";

import * as React from "react";
import { action } from "mobx";
import { observer } from "mobx-react";

import * as CustomLists from "../../models/customLists";
import CategoryMenuStore from "../../stores/CategoryMenuStore";
import { FolderCard } from "./FolderCard";

var ReactList = require("react-list");

require("../../styles/commonStyles.css");

interface FetchListProps extends React.Props<any> {
    store: CategoryMenuStore;
}

@observer
export class FolderBrowserFetchList extends React.Component<FetchListProps> {
    public render() {
        let totalCount = this.props.store.folderBrowserCategoryMenuFolder.visibleItems.length + 1;
        return <ReactList type="simple" itemRenderer={this.renderItem} length={totalCount} pageSize={20} />;
    }

    @action
    private renderItem = (index: number, key: string) => {
        if (this.props.store.folderBrowserCategoryMenuFolder.visibleItems === undefined) {
            return null;
        }

        let totalItems = this.props.store.folderBrowserCategoryMenuFolder.visibleItems.length;
        let singleItemLoaded = totalItems === 1 && index === 1;

        if (this.props.store.folderBrowserCategoryMenuFolder.visibleItems.length <= index && !singleItemLoaded) {
            log.verbose("Don't do anything.");
        } else if (this.props.store.folderBrowserCategoryMenuFolder.visibleItems.length > index) {
            let item = this.props.store.folderBrowserCategoryMenuFolder.visibleItems[index];
            if (item instanceof CustomLists.Folder) {
                return (
                    <FolderCard
                        showOptions={false}
                        store={this.props.store}
                        onBackgroundClickedCallback={this.props.store.updateCurrentFolderBrowserFolder}
                        fontSize={14}
                        key={key}
                        folder={item as CustomLists.Folder}
                    />
                );
            }
        }
        return null;
    };
}
